import "./App.css";
import {
  Section,
  Statistics,
  FeedbackOptions,
  Notification,
  FeedbackContext
} from "./components";
import { useState, useEffect, useRef } from "react";

const App = () => {
  const [state, setState] = useState({
    good: 0,
    neutral: 0,
    bad: 0,
  });

  const handleFeedback = (type) => {
    setState((prevState) => ({
      ...prevState,
      [type]: prevState[type] + 1,
    }));
  };

  const countTotalFeedback = () => {
    return state.good + state.neutral + state.bad;
  };

  const countPositiveFeedbackPercentage = () => {
    const total = countTotalFeedback();
    return total ? Math.round((state.good / total) * 100) : 0;
  };

  const firstButtonRef = useRef(null);

  return (
    <FeedbackContext.Provider value={{ state, handleFeedback }}>
      <div>
        <Section title="залиште відгук">
          <FeedbackOptions
            options={["good", "neutral", "bad"]}
            ref={firstButtonRef}
          />
        </Section>

        <Section title="Статистика">
          {countTotalFeedback() > 0 ? (
            <Statistics
              good={state.good}
              neutral={state.neutral}
              bad={state.bad}
              total={countTotalFeedback()}
              positivePercentage={countPositiveFeedbackPercentage()}
            />
          ) : (
            <Notification message="There is no feedback" />
          )}
        </Section>
      </div>
    </FeedbackContext.Provider>
  );
};
export default App;
